import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'

import { GlgSelect, StickToBreadcrumb } from 'SharedComponents'

const CustomerFilterComponent = (props) => {
  const customers = props.customers.map(({ id, name, url }) => ({
    value: id,
    label: name,
    url,
  }))

  const accessInOtherAccountText = [
    (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.customer_filter_component.access_in_other_account')),
    (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.customer_filter_component.select_different_account')),
  ].join(' ')

  return (
    props.customers.length > 1 && !props.isSimGolf &&
      <StickToBreadcrumb className='customer-filter-wrapper'>
        <Row>
          <Col xs={ 9 }>
            <div className='text'>
              { accessInOtherAccountText }
            </div>
          </Col>
          <Col xs={ 3 }>
            <GlgSelect
              items={ customers }
              defaultValue={ props.activeCustomerId }
            />
          </Col>
        </Row>
      </StickToBreadcrumb>
  )
}

CustomerFilterComponent.propTypes = {
  customers: PropTypes.array.isRequired,
  activeCustomerId: PropTypes.string,
}

export default CustomerFilterComponent
